import React from 'react'

const PaperplaneIcon = (props) => {
	return(
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17.228" viewBox="0 0 20 17.228"><path d="M0 42.6a.969.969 0 0 0 .693.877l7.326 2.215.269 5.05a.5.5 0 0 0 .339.441.459.459 0 0 0 .163.029.5.5 0 0 0 .375-.167l2.59-2.868 3.671 2.541a.963.963 0 0 0 .555.175.985.985 0 0 0 .959-.783l3.047-15.53a.5.5 0 0 0-.677-.559l-18.721 7.621a.984.984 0 0 0-.589.958zm9.219 6.89l-.165-3.19 1.876 1.3zm6.747.388l-6.68-4.626 9.37-9.064zm1.66-14.09l-9.262 8.962-7.318-2.211z" transform="translate(0 -33.985)"fill={props.fill} /></svg>
	)
}

export default PaperplaneIcon